export const formLabelClasses =
  "mb-2 block text-base font-semibold leading-[1.2] text-slate-900";

const formControlClasses =
  "mb-3 w-full min-w-0 rounded-control bg-surface-subtle [&_.MuiOutlinedInput-root]:rounded-control [&_.MuiOutlinedInput-root]:bg-surface-subtle [&_.MuiOutlinedInput-notchedOutline]:!border-0";

export const formInputClasses = `${formControlClasses} [&_.MuiOutlinedInput-root]:h-[48px] [&_.MuiOutlinedInput-input]:py-0`;

// Match regular inputs while allowing selected chips to wrap onto additional rows.
export const formAutocompleteClasses = `${formControlClasses} [&_.MuiOutlinedInput-root]:min-h-[48px] [&_.MuiAutocomplete-inputRoot]:!pl-[14px] [&_.MuiAutocomplete-inputRoot]:!py-[6px] [&_.MuiAutocomplete-inputRoot_.MuiAutocomplete-input]:!min-h-[36px] [&_.MuiAutocomplete-inputRoot_.MuiAutocomplete-input]:!p-0 [&_.MuiAutocomplete-tag]:!m-0.5`;

export const formModalTriggerClasses =
  "mb-3 flex min-h-[48px] w-full items-center rounded-control border-0 bg-surface-subtle px-[14px] py-3 text-left text-base font-medium leading-[1.5] text-slate-900 outline-none transition focus:ring-2 focus:ring-inset focus:ring-action/30";
